const looksLikeInternalCode = (value: string) => /^[a-z0-9]+(?:_[a-z0-9]+)+$/i.test(value.trim())

export const getPayOrQuitApiError = (error: unknown): string => {
  if (typeof error === 'string') {
    return looksLikeInternalCode(error)
      ? 'The request could not be completed. Please try again or contact Engineering.'
      : error
  }

  if (error && typeof error === 'object') {
    const responseData = (error as { response?: { data?: { error?: unknown; message?: unknown } } })
      .response?.data
    const directError = (error as { error?: unknown }).error
    const message = (error as { message?: unknown }).message
    const candidate = responseData?.message ?? message ?? responseData?.error ?? directError

    if (typeof candidate === 'string' && candidate.trim()) {
      if (looksLikeInternalCode(candidate)) {
        return 'The request could not be completed. Please try again or contact Engineering.'
      }
      if (!['Bad Request', 'Internal Server Error', 'Service Unavailable'].includes(candidate)) {
        return candidate
      }
    }
  }

  return 'Please try again. If this keeps happening, contact Engineering.'
}
